import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { gsFilters, gsHasInitialized, gsMapScriptLoaded, gsPropertyListSort, gsStateList, gsCountiesWithRealtyList, gsUserLocation } from '../AppState';
import { useGetUserSearch } from './useUserSearchLocation';
import { getRealtyCountiesandStates } from '../services/getCounties';

export const useInitializeState = () => {

	const [getLocationViaUrlState, getCurrentLocation] = useGetUserSearch();
	const setGsPropertyListSort = useSetRecoilState(gsPropertyListSort);
	const setGsFilters = useSetRecoilState(gsFilters);
	const [hasInitialized, setHasInitialized] = useRecoilState(gsHasInitialized);
	const mapScriptLoaded = useRecoilValue(gsMapScriptLoaded);

	const setGsStatesList = useSetRecoilState(gsStateList);
	const setGsUserLocation = useSetRecoilState(gsUserLocation);
	const setCountiesWithRealtyList = useSetRecoilState(gsCountiesWithRealtyList);

	useEffect(() => {
		const setFilterStateFromUrl = (pathSegments: string[]) => {
			const filterSegmentIndex = pathSegments.findIndex(value => value === 'filters');
			if (filterSegmentIndex !== -1) {
				const filters = pathSegments[filterSegmentIndex + 1].split(',');

				let filtersDelta = {};
				filters.forEach((filter) => {
					const splitFilter = filter.split('=');
					const [filterKey, filterValue] = splitFilter;
					if (splitFilter.length === 2) {
						switch (filterKey) {
							case 'homeTypes':
								{
									const homeTypes = filterValue.split('-');
									filtersDelta = { ...filtersDelta, [filterKey]: homeTypes };
								}
								break;
							case 'searchArea':
								{
									const homeTypes = JSON.parse(filterValue.replace(/\+/g, ','));
									filtersDelta = { ...filtersDelta, [filterKey]: homeTypes };
								}
								break;
							default:
								{
									const filterValueNumber = Number(filterValue);
									filtersDelta = { ...filtersDelta, [filterKey]: isNaN(filterValueNumber) ? filterValue : filterValueNumber };
								}
								break;
						}
					}
				});
				setGsFilters(currVal => ({ ...currVal, ...filtersDelta, initialized: true }));
			} else
				setGsFilters(currVal => ({ ...currVal, initialized: true }));

		};

		const setSortStateFromUrl = (pathSegments: string[]) => {
			const sortSegmentIndex = pathSegments.findIndex(value => value === 'sort');

			if (sortSegmentIndex !== -1) {
				switch (pathSegments[sortSegmentIndex + 1]) {
					case 'pricedescending':
						setGsPropertyListSort(1);
						break;
					case 'priceascending':
						setGsPropertyListSort(2);
						break;
					default:
						setGsPropertyListSort(0);
				}
			}
		};

		const initializeState = () => {
			const setActiveRealtyStatesAndCounties = async () => {
				const realtyCountiesAndStates = await getRealtyCountiesandStates();
				if (realtyCountiesAndStates !== false) {
					setGsStatesList(realtyCountiesAndStates.realtyStateNames);
					setCountiesWithRealtyList(realtyCountiesAndStates.countiesWithRealty);
				}
			};

			setActiveRealtyStatesAndCounties();

			const pathSegments = window.location.pathname.split('/');

			if (pathSegments.includes('location')) {
				//console.log('%cFetching from URL: ', 'background: red;', pathSegments)
				getLocationViaUrlState();
			} else {
				setGsUserLocation(currVal => ({...currVal, initialized: true}));
			}

			// url filters
			setFilterStateFromUrl(pathSegments);

			// url sort
			setSortStateFromUrl(pathSegments);
		};

		if (mapScriptLoaded && !hasInitialized) {
			initializeState();
			setHasInitialized(true);
		}
	}, [mapScriptLoaded, getCurrentLocation, getLocationViaUrlState, setGsFilters, setGsPropertyListSort, setHasInitialized, hasInitialized, setGsStatesList]);

};